<template>
  <v-dialog v-model="open" max-width="550px">
    <v-card>
      <v-card-title class="text-h5">
        <v-icon class="pr-2" large color="primary">mdi-alert</v-icon>
        {{ $t('message.pages.video.downloadBackupModal.title') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        v-html="
          $t('message.pages.video.downloadBackupModal.message', {
            toggle: $t('message.pages.qualitySettings.originalFiles.label'),
          })
        "
        class="pb-1"
      />
      <v-card-actions class="px-6 py-5">
        <v-spacer></v-spacer>
        <base-btn class="mr-4" type="secondary" @click="open = false">
          {{ $t('message.close') }}
        </base-btn>
        <base-btn
          @click="
            open = false
            $router.push({ name: 'Quality' })
          "
        >
          {{ $t('message.pages.video.downloadBackupModal.action') }}
        </base-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// components
import BaseBtn from '@/components/BaseBtn.vue'

export default {
  name: 'DownloadAlertDialog',
  components: {
    BaseBtn,
  },
  data: () => ({
    open: false,
  }),
  mounted() {
    this.$root.$on('DownloadAlertDialog', () => {
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('DownloadAlertDialog')
  },
}
</script>
